import { getProductLabel } from '@/libs/llc/database/property';

interface MessageMap {
  [key: string]: string;
}

enum ErrorMessages {
  'No Search Result' = '検索結果がありません。',
  'User does not exist.' = '入力されたメールアドレスは存在しません。',
  'Incorrect username or password.' = 'メールアドレスかパスワードのいずれかが誤っています。',
  'Incorrect password.' = '現在のパスワードが誤っています。',
  'Username/client id combination not found.' = '入力されたメールアドレスは存在しません。',
  'Username and Pool information are required.' = '入力されたメールアドレスは存在しません。',
  'Invalid verification code provided, please try again.' = '不正な認証コードです。再度確認して、入力してください。',
  'Invalid code provided, please request a code again.' = '不正な認証コードです。再度確認して、入力してください。',
  'User is not confirmed.' = '検証コードによる認証がされていません。',
  'TargetName does not exist.' = '該当する事業所がありません。',
  'An account with the given email already exists.' = '入力されたメールアドレスは既に登録されています。',
  'jwt expired' = 'セッションが切れました、更新し直してください。',
  'TokenExpiredError: jwt expired' = 'セッションが切れました、更新し直してください。',
  'timeout of 20000ms exceeded' = 'タイムアウトしました。',
  'Processing timeout OR Command not accepted. ' = 'タイムアウト、あるいは操作が無効です。',
  'Password attempts exceeded' = 'パスワード入力の試行回数が超えました。15分間、ログインできません。',
  'code is wrong' = '入力されたコードは誤っています。',
  'code is expired' = '入力されたコードは期限切れです。',
  'Message Rejected' = 'メッセージが送信できませんでした。',
  'deviceId is invalid' = '入力されたデバイスIDがCPに存在しません',
  'Already reservation exists.' = '既に入力された時間で、予約が存在しています。',
  'Reservations cannot be created before the current time.' = '現在時間よりも前は、予約を作成できません。',
  'schedule date is invalid.' = '入力された時間は不正です。',
  'reservation Failed.' = '予約に失敗しました。再度、予約画面から予約し直してください。',
  'DoubleBooking has occured.' = '既に予約が登録されています。再度、予約画面から予約し直してください。',
  'Reservations have exceeded limit.' = '同時予約可能数を超えています。再度、予約画面から予約し直してください。',
  'Requested room is out of publication period.' = '掲載期間外のため、予約を受け付けられませんでした。再度、予約画面から予約し直してください。',
  'Requested room is out of reservation period.' = '予約受付期間外のため、予約を受け付けられませんでした。再度、予約画面から予約し直してください。',
  'Requested room is out of reservation expired.' = '予約受付時間外のため、予約を受け付けられませんでした。再度、予約画面から予約し直してください。',
  'Requested receipt is not found.' = '領収書が存在しません。',
  'Closed assignment already exists.' = '休業の予約は既に登録されています。再度、予約画面から予約し直してください。',
  'Bussiness has been closed.' = '入力された予約時間は営業中ではありません。',
  'Resource DoubleBooking has occured.' = '既にリソースが登録されています。再度、リソース画面から予約し直してください。',
  'Username should be email.' = '適切なメールアドレスを入力してください。',
  'Membership authentication code status is invalid.' = '会員認証コードの状態が不正なため、リクエストが拒否されました。',
  'Your card has been declined.' = 'カードによるお支払いが拒否されました。',
  'Your card has insufficient funds.' = '残高不足のため、カードによるお支払いが拒否されました。',
  'Your card number is invalid.' = 'カード番号の誤りのため支払いが拒否されました。',
  "Your card's security code is incorrect." = 'セキュリティコードの誤りのため支払いが拒否されました。',
  'Your card has expired.' = '期限切れのカードのため支払いが拒否されました。',
  'The provided PaymentMethod has failed authentication.' = '支払方法を認証できません。別の支払い方法を選択して、もう一度お試しください。',
  'An error occurred while processing your card.' = '処理中にエラーが発生しました。もう一度お試しください。',
  'Your card is unavailable.' = 'ご指定のカードは利用できません。',
  'externalDeviceId is invalid' = '外部デバイスIDが無効です。',
  'jwt expired.' = 'セッションが切れました、更新し直してください。',
  'Request failed with status code 401' = 'セッションが切れました、更新し直してください。',
  'timeout of 100000ms exceeded' = 'タイムアウトしました、再度検索してください。',
  'Ip Address is out of range.' = 'IPアドレスが範囲外のため、ログイン出来ません。',
  'Payload Too Large.' = 'ファイルの容量がサーバーの制限を超えています。',
  'Not authenticated.' = 'ユーザー認証に失敗しました。ログインしてからもう一度お試しください。',
  'Not authorized.' = 'ユーザーの権限が不足しているため、リクエストが拒否されました。',
  'Internal Server Error' = 'サーバーエラーが発生しました。',
  'Throughput Error' = 'リクエスト数制限エラーが発生しました。少しお待ち頂いた後、再実行をお願いします。',
  'File format CSV Error' = 'アップロードするファイルの形式はPDFでお願いします。',
  'Reservation is double booking.' = '選択した日時の予約件数が上限に達したため、予約を受け付けられませんでした。お手数おかけしますが、再度予約を行ってください。',
  'This request is invalid' = '無効なリクエストです。',
  'Invalid code or auth state for the user.' = '入力されたコードは誤っています。再度確認して、入力してください。',
  'Invalid session for the user, session is expired.' = 'セッションが切れています、再度認証コードを発行してください。',

}

enum SuccessMessages {
  'password reset success.' = 'パスワードの変更に成功しました。',
  'emailAddress was changed sucessfully.' = 'メールアドレスの変更に成功しました。',
  'Activate success.' = 'アクティベーションに成功しました。追加したメールアドレスと初期パスワードでログインしてください。',
  'ChangeActivate success.' = 'アクティベーションに成功しました。変更したメールアドレスでログインしてください。',
  'Send email successfully.' = '入力頂いたメールアドレスに検証コードを送りました。',
  'Auth has been registered successfully.' = 'ユーザー追加に成功しました。追加したメールアドレスにメールが送信されました。検証コードの認証が必要です。',
  'Auth has been deleted successfully.' = 'ユーザー削除に成功しました。',
  'Auth has been editted successfully.' = 'ユーザー情報保存に成功しました。',
  'Coupons has been registered successfully.' = 'クーポン追加に成功しました。',
  'Coupons has been deleted successfully.' = 'クーポン削除に成功しました。',
  'Coupons has been editted successfully.' = 'クーポン保存に成功しました。',
  'resources has been registered successfully.' = 'リソース追加に成功しました。',
  'resources has been deleted successfully.' = 'リソース削除に成功しました。',
  'resources has been editted successfully.' = 'リソース保存に成功しました。',
  'resource/reservation has been registered successfully.' = 'リソース予約の追加に成功しました。',
  'resource/reservation has been deleted successfully.' = 'リソース予約の削除に成功しました。',
  'resource/reservation has been editted successfully.' = 'リソース予約の保存に成功しました。',
  'resource on site has been registered successfully.' = '現地決済商品の追加に成功しました。',
  'resource on site has been deleted successfully.' = '現地決済商品の削除に成功しました。',
  'resource on site has been editted successfully.' = '現地決済商品の保存に成功しました。',
  'account has been registered successfully.' = 'アカウント追加に成功しました。',
  'account has been deleted successfully.' = 'アカウント削除に成功しました。',
  'account has been editted successfully.' = 'アカウント保存に成功しました。',
  'property has been registered successfully.' = '事業所追加に成功しました。',
  'property has been deleted successfully.' = '事業所削除に成功しました。',
  'property has been editted successfully.' = '事業所保存に成功しました。',
  'user has been editted successfully.' = 'ユーザー情報の更新に成功しました。',
  'membership has been editted successfully.' = '会員情報の更新に成功しました。',
  'membership authentication has been registered successfully.' = '会員認証コードの追加に成功しました。',
  'membership authentication has been editted successfully.' = '会員認証コードの更新に成功しました。',
  'membership authentication has been canceled successfully.' = '会員認証コードの無効化に成功しました。',
  'reservation has been registered successfully.' = '予約追加に成功しました。',
  'reservation has been deleted successfully.' = '予約削除に成功しました。',
  'reservation has been editted successfully.' = '予約保存に成功しました。',
  'Operate lock successfully.' = 'スマートロック操作に成功しました。',
  'Update bussinessday successfully.' = '営業情報の保存に成功しました。',
  'Bulk register succeed.' = '新規事業所登録に成功しました。その他の情報を保存してください。',
  'Environment setting has been updated.' = '詳細設定が更新されました。',
  'reservation cancel Successed' = '予約キャンセルに成功しました。',
}

export function getErrorMessageMap(property: any): MessageMap {
  const text = getProductLabel(property);
  return Object.assign(ErrorMessages, {
    'roomId is Invalid': `${text}IDが存在しません`,
  });
}

export function getSuccessMessageMap(property: any): MessageMap {
  const text = getProductLabel(property);
  return Object.assign(SuccessMessages, {
    'rooms has been registered successfully.': `${text}追加に成功しました。`,
    'rooms has been deleted successfully.': `${text}削除に成功しました。`,
    'rooms has been editted successfully.': `${text}保存に成功しました。`,
  });
}
